<template>
  <v-container class="pa-0">
    <v-row>
      <v-col cols="8" class="pa-0">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              small
              v-bind="attrs"
              v-on="on"
              @click="type = type === 'flatDiscount' ? null : 'flatDiscount'"
              :color="type === 'flatDiscount' ? 'warning' : ''"
            >
              <v-icon small>mdi-sale</v-icon>
            </v-btn>
          </template>
          <span>Flat discount</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              small
              v-bind="attrs"
              v-on="on"
              @click="type = type === 'columnJump' ? null : 'columnJump'"
              :color="type === 'columnJump' ? 'warning' : ''"
            >
              <v-icon small>mdi-table-column-plus-after</v-icon>
            </v-btn>
          </template>
          <span>Column jump</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              small
              v-bind="attrs"
              v-on="on"
              @click="type = type === 'columnMin' ? null : 'columnMin'"
              :color="type === 'columnMin' ? 'warning' : ''"
            >
              <v-icon small>mdi-table-column-width</v-icon>
            </v-btn>
          </template>
          <span>Minimum column</span>
        </v-tooltip>
      </v-col>
      <v-col cols="4" class="pa-0">
        <v-text-field
          type="number"
          single-line
          dense
          width="4"
          v-model="val"
          :error="val < 0 || val > 100"
          :disabled="type === null"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: ['value'],
  data: () => ({
    type: null,
    val: 0
  }),
  created () {
    if (this.value) {
      this.type = this.value.type
      this.value = this.value.value
    }
  },
  watch: {
    type () {
      this.$emit('input', { type: this.type, value: parseInt(this.val) })
    },
    val () {
      this.$emit('input', { type: this.type, value: parseInt(this.val) })
    }
  }
}
</script>

<style scoped>
  .container {
    width: 150px;
    height: 28px;
  }
</style>
